export default __webpack_public_path__ + "static/media/ferly.f672ff11.svg";